import {MenuStrategy} from "../MenuStrategy";

export class DispositiviListaDispositiviMenuStrategy extends MenuStrategy {
   constructor() {
    super('Lista Dispositivi', 'Lista Dispositivi', 'app-devices-list');
  }
}
